var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2083 18.9583C11.2083 19.6687 11.7896 20.25 12.5 20.25C13.2104 20.25 13.7917 19.6687 13.7917 18.9583C13.7917 18.2479 13.2104 17.6667 12.5 17.6667C11.7896 17.6667 11.2083 18.2479 11.2083 18.9583ZM11.2083 0.875V6.04167H13.7917V3.56167C18.1704 4.19458 21.5417 7.94042 21.5417 12.5C21.5417 17.4987 17.4987 21.5417 12.5 21.5417C7.50125 21.5417 3.45833 17.4987 3.45833 12.5C3.45833 10.33 4.22042 8.34083 5.49917 6.79083L12.5 13.7917L14.3212 11.9704L5.53792 3.18708V3.21292C2.70917 5.33125 0.875 8.68958 0.875 12.5C0.875 18.9196 6.0675 24.125 12.5 24.125C18.9196 24.125 24.125 18.9196 24.125 12.5C24.125 6.08042 18.9196 0.875 12.5 0.875H11.2083ZM20.25 12.5C20.25 11.7896 19.6687 11.2083 18.9583 11.2083C18.2479 11.2083 17.6667 11.7896 17.6667 12.5C17.6667 13.2104 18.2479 13.7917 18.9583 13.7917C19.6687 13.7917 20.25 13.2104 20.25 12.5ZM4.75 12.5C4.75 13.2104 5.33125 13.7917 6.04167 13.7917C6.75208 13.7917 7.33333 13.2104 7.33333 12.5C7.33333 11.7896 6.75208 11.2083 6.04167 11.2083C5.33125 11.2083 4.75 11.7896 4.75 12.5Z",
    fill: "#FEA801"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c290d0accf0eb35890681d9a439c2598.svg";
export { ForwardRef as ReactComponent };